import * as React from "react";
import type { SVGProps } from "react";

interface GoalProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Goal = ({ cancelled = false, ...props }: GoalProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1.75 2.35)">
        <ellipse
          cx={10.28}
          cy={9.75}
          fill="#FFF"
          stroke="#FFF"
          strokeWidth={1.91}
          rx={9.75}
          ry={9.7}
        />
        <ellipse
          cx={10.28}
          cy={9.75}
          stroke="#000"
          strokeWidth={1.3}
          rx={9.44}
          ry={9.39}
        />
      </g>
      <path
        fill="#000"
        d="m9.75 9.93 4.02-.55 1.9 3.62-2.93 2.83-3.72-1.87zM4.1 7.53c.48-.94.9-1.6 1.27-1.95a8 8 0 0 1 1.98-1.23l1.82.82-1.18 3.12-3.17 1.09zm17.43 4.32c-.06.95-.13 1.67-.2 2.18a7.5 7.5 0 0 1-.84 2.13l-2.26.18-.52-2.93 1.62-3.37zm-5.56 8.77c-1 .45-1.76.7-2.27.74-.5.04-1.32.04-2.44 0l-1.4-1.9 3.47-1.56 2.85.5zM4.59 18.03a4.6 4.6 0 0 1-1.22-1.8 14 14 0 0 1-.32-1.7l1.28-2.6 2.28 2.7.29 3.6zM14.1 3.41c.8.1 1.45.24 1.92.44s1.09.66 1.85 1.36l.17 1.8-3.57-.15-2.7-2.3L14.1 3.4Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Goal;
